import InlineCode from '@primer/gatsby-theme-doctocat/src/components/inline-code';
import { Box as Container } from '@primer/react';
import { PropTableValues } from "../../../../src/components";
import { Label } from '@primer/react';
import * as React from 'react';
export default {
  InlineCode,
  Container,
  PropTableValues,
  Label,
  React
};